<template>
  <div>
    <main-toolbar>
      <v-toolbar-title>Data</v-toolbar-title>
      <DataParamsPicker
        slot="extension"
        v-model="dataParams"
        @input="update"
      >
        <div slot="actions">
          <v-btn
            style="margin-top: -5px;"
            icon
            light
            small
            slot="actions-start"
            v-if="dataParams.dateRange && dataParams.dateRange.start && dataParams.dateRange.end && dataParams.machine && dataParams.testType"
            @click="exportData = true"
            :disabled="loading"
          >
            <v-icon>fa-file-download</v-icon>
          </v-btn>
        </div>
      </DataParamsPicker>
    </main-toolbar>
    <DataTable :params="dataParams" />
    <ExportDataDialog
      v-if="exportData"
      :params="dataParams"
      @close="exportData = false"
    />
  </div>
</template>

<script>
import DataParamsPicker from '@/components/DataParamsPicker'
import DataParamsMixin from '@/mixins/DataParamsMixin'
import DataTable from './DataTable'
import ExportDataDialog from './ExportDataDialog'

export default {
  mixins: [DataParamsMixin],
  components: {
    DataParamsPicker,
    DataTable,
    ExportDataDialog
  },
  data () {
    return {
      loading: false,
      dataParams: {},
      exportData: false
    }
  },
  methods: {
    async update () {
      this.saveDataParams()
    }
  },
  mounted () {
    this.loadDataParams()
  }
}
</script>
